import React, { Component } from 'react';

export default class view extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}
	navcheck = (e) => {
		this.props.data.CIN = '';
		this.props.navigate('A2')
	}
	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>You have not completed any authorizations for this member.</p>

				<div className="button" onClick={() => this.navcheck()}>Perform an inquiry on a different CIN</div>
			</div>
		);
	}
}